export type MachineDetailTab = 'overview' | 'picklists' | 'refills';

export function parseMachineDetailTab(value: string | null | undefined): MachineDetailTab {
  if (value === 'picklists' || value === 'refills') return value;
  return 'overview';
}

export function productDetailPath(productId: string): string {
  return `/inventory/products/${productId}`;
}

export function machineDetailPath(machineId: string, tab?: MachineDetailTab): string {
  const base = `/machines/${machineId}`;
  const resolved = parseMachineDetailTab(tab);
  if (resolved === 'overview') return base;
  return `${base}?tab=${resolved}`;
}

export function machinePicklistPath(machineId: string, picklistId?: string): string {
  const base = `/machines/${machineId}/picklist`;
  if (picklistId == null || picklistId.length === 0) return base;
  return `${base}?picklistId=${encodeURIComponent(picklistId)}`;
}

/** Hub, spoke, venue, or machine detail — null when type is unknown or unsupported. */
export function locationDetailPath(locationType: string, locationId: string): string | null {
  const type = locationType.trim().toUpperCase();
  if (type === 'HUB') return `/locations/hubs/${locationId}`;
  if (type === 'SPOKE') return `/locations/spokes/${locationId}`;
  if (type === 'VENUE') return `/locations/venues/${locationId}`;
  if (type === 'MACHINE') return machineDetailPath(locationId);
  return null;
}

/** Warehouse hub/spoke detail — null for venues and other types. */
export function warehouseDetailPath(warehouseType: string, warehouseId: string): string | null {
  return locationDetailPath(warehouseType, warehouseId);
}
